export class TiposOcupacionesCapacidadPagos {
  idTipoOcupacionConfiguracionCapacidadPago : string | null = null;
  idTipoOcupacionConfiguracion : string | null = null;
  idFuenteCapacidadPago : string | null = null;
  indicadorPorcentajePerfil : boolean = false;
  indicadorEstimadorGasto : boolean = false;
  indicadorAplicaGastoIncome : boolean = false;
  indicadorLanzaNoAplicaOferta : boolean = false;
  indicadorHabilitado : boolean = false;
  auditoriaFecha : Date;
  auditoriaUsuario : string | null = null;
  indicadorTransferenciaAch : boolean = false;

  //transient
  codigoFuenteCapacidadPago: string | null = null;
  fuenteCapacidadPago : string | null = null;
}
